module.exports = __webpack_public_path__ + "img/img46.f40c07ab.svg";